module.exports = "/assets/779a4996a4d11d6d250be8bcc882d34b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/EP.png
// module id = 2470
// module chunks = 0